var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestraintsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SE 40mm@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.63636364 C0,1.62807273 1.62807273,0 3.63636364,0 L5.09090909,0 C7.0992,0 8.72727273,1.62807273 8.72727273,3.63636364 L8.72727273,8.72727273 L0,8.72727273 L0,3.63636364 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SE-40mm",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Restraints-&-Driver-Assistance",
    transform: "translate(-0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9993455,18.0006628 L23.9993455,24 L17.6001455,24 L17.6001455,22.5001997 L22.3995636,22.5001997 L22.3995636,18.0006628 L23.9993455,18.0006628 Z M1.59979636,18.0005269 L1.59979636,22.5000637 L6.40079273,22.5000637 L6.40079273,23.999864 L0,23.999864 L0,18.0005269 L1.59979636,18.0005269 Z M6.40079273,0.000302397974 L6.40079273,1.50013342 L1.59979636,1.50013342 L1.59979636,6.00113874 L0,6.00113874 L0,0.000302397974 L6.40079273,0.000302397974 Z M24,0 L24,6.00083961 L22.4002182,6.00083961 L22.4002182,1.49983429 L17.6008,1.49983429 L17.6008,0 L24,0 Z",
    id: "Shape",
    fill: "#00095B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5454545,4.14164364 C14.5454545,5.74829091 13.2429818,7.05076364 11.6363636,7.05076364 C10.0297455,7.05076364 8.72727273,5.74829091 8.72727273,4.14164364 C8.72727273,2.53499636 10.0297455,1.23255273 11.6363636,1.23255273 C13.2429818,1.23255273 14.5454545,2.53499636 14.5454545,4.14164364 Z",
    id: "Path",
    fill: "#00095B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09090909,20.8689455 C5.09090909,18.8605818 6.71896727,17.2325818 8.72727273,17.2325818 L14.5454545,17.2325818 C16.5537455,17.2325818 18.1818182,18.8605818 18.1818182,20.8689455 L5.09090909,20.8689455 Z",
    id: "Path",
    fill: "#00095B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(7.2727, 7.7273)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#00095B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.9233, -5.0879)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 11.0752509 9.79128 0 13.5612436 3.33293818 3.77002182 14.4081964"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.37354909 15.03096 14.1648073 3.95568727 20.2789891 9.36099636 10.4877164 20.4362691"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestraintsIcon);
export default __webpack_public_path__ + "static/media/restraints-icon.23159d2eedd6aee66f6f2a51378fbf0b.svg";
export { ForwardRef as ReactComponent };